var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg30Plus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.042,
    height: 113.548,
    viewBox: "0 0 155.042 113.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_269",
    x: 106.484,
    y: 0,
    width: 48.559,
    height: 48.558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_30_plus",
    "data-name": "30_plus",
    transform: "translate(-240.792 -1385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16022",
    "data-name": "Path 16022",
    d: "M-71.856-75.213h15.207c.959-6.987,6.028-13.563,16.988-13.563,10.686,0,16.3,5.754,16.3,14.385,0,10.686-8.631,14.8-22.742,14.933h-3.7V-46.58h3.562c16.3,0,24.8,4.521,24.8,17.673,0,9.316-5.754,16.44-17.4,16.44-11.782,0-18.632-7.124-19.317-16.44h-15.07C-72.267-9.316-57.608.548-38.7.548-17.878.548-6.644-11.508-6.644-27.4c0-13.837-6.713-22.468-17.125-25.619v-.548c7.809-2.6,15.344-10.686,15.344-22.6,0-14.522-10.823-26.03-30.688-26.03C-57.334-102.2-70.76-92.475-71.856-75.213ZM.206-51.238C.206-22.194,7.878-.274,35.826-.274s35.62-21.92,35.62-50.964c0-28.5-7.672-50.416-35.62-50.416S.206-79.734.206-51.238Zm55.9,0c0,19.591-2.055,36.716-20.276,36.716S15.55-31.647,15.55-51.238c0-18.632,2.055-36.168,20.276-36.168S56.1-69.87,56.1-51.238Z",
    transform: "translate(314.019 1498)",
    fill: "#38c1f8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 240.79, 1385)",
    filter: "url(#Ellipse_269)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269-2",
    "data-name": "Ellipse 269",
    cx: 15.279,
    cy: 15.279,
    r: 15.279,
    transform: "translate(115.48 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M17.7-17.484v-2.944H11.141V-26.95H8.346v6.522H1.75v2.944h6.6v6.522h2.795v-6.522Z",
    transform: "translate(361.979 1425.403)",
    fill: "#38c1f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg30Plus);
export default __webpack_public_path__ + "static/media/30_plus.22ef30bdf9eef0e97365b85e167035f0.svg";
export { ForwardRef as ReactComponent };